import React from 'react'
import '../App.css'
import Navbar from '../components/navbar.js'
import Footer from '../components/footer.js'

const Services = () => {
  document.title = "Our Services | iNails & Spa";
  return (
    <>
      <Navbar />
      <div className='services'>
        <div className ='title title1'>
          <h1><span className="font-letter">O</span>ur <span className="font-letter">S</span>ervices</h1>
        </div>
        <div className='services-container'>
          <div className='services-content'>
            <div className='services-left'>
              <ol className='list-order'>
                <div className='services-title'>
                    <span>MANICURE</span> 
                </div> 
                <li><span className="name">Gel Builder</span><span className="dots"></span><span className="price">$45</span></li>
                <li><span className="name">Manicure with Gel color</span><span className="dots"></span><span className="price">$37</span></li>
                <li><span className="name">Take-off w/ Gel Manicure</span><span className="dots"></span><span className="price">$41</span></li>
                <li><span className="name">Gel Color Change - Hand</span><span className="dots"></span><span className="price">$28+</span></li>
                <li><span className="name">Regular Manicure</span><span className="dots"></span><span className="price">$20</span></li>
                <li><span className="name">European Manicure</span><span className="dots"></span><span className="price">$26</span></li>
                <li><span className="name">Deluxe Manicure</span><span className="dots"></span><span className="price">$33</span></li>
                <li><span className="name">Neck, Shoulder Massage (15 mins)</span><span className="dots"></span><span className="price">$20</span></li>
                <p className="note">(All manicure & pedicure services including hands, foreams, lower legs, feet, reflexology massage and polish)</p>
              </ol>
            </div>
            <div className='services-middle'>
              <ol className='list-order'>
                <div className='services-title'>
                  <span>PEDICURE</span> 
                </div> 
                {/* <hr/> */}
                <li><span className="name">Spa Pedicure</span><span className="dots"></span><span className="price">$30</span></li>
                <li><span className="name">European Spa Pedicure</span><span className="dots"></span><span className="price">$40</span></li>
                <li><span className="name">Deluxe Spa Pedicure</span><span className="dots"></span><span className="price">$50</span></li>
                <li><span className="name">Organic Deluxe Spa Pedicure</span><span className="dots"></span><span className="price">$61</span></li>
                <li><span className="name">Spa Pedicure with Gel</span><span className="dots"></span><span className="price">$47</span></li>
                <li><span className="name">Gel Color Change - Toe</span><span className="dots"></span><span className="price">$30</span></li>
                <li><span className="name">Foot Massage w/ Marine Mask (30 mins)</span><span className="dots"></span><span className="price">$35</span></li>
              </ol>
            </div>
            <div className='services-right'>
              <ol className='list-order'>
                <div className='services-title'>
                  <span>FILL - IN</span> 
                </div> 
                <li><span className="name">Regular Fill</span><span className="dots"></span><span className="price">$30+</span></li>
                <li><span className="name">Fill w/ Gel Color</span><span className="dots"></span><span className="price">$39+</span></li>
                <li><span className="name">Solar Pink & White Fill</span><span className="dots"></span><span className="price">$53+</span></li>
                <li><span className="name">IBD Gel Fill</span><span className="dots"></span><span className="price">$48+</span></li>
                <li><span className="name">Powder Color Fill</span><span className="dots"></span><span className="price">$45+</span></li>
                <li><span className="name">Ombre Pink & White Fill</span><span className="dots"></span><span className="price">$50+</span></li>
                <li><span className="name">Fill on Toes</span><span className="dots"></span><span className="price">$29</span></li>
                {/* <li><span className="name">Take-Off Only</span><span className="dots"></span><span className="price">$15</span></li> */}
                {/* <li><span className="name">Take-Off w/ New Set</span><span className="dots"></span><span className="price">$9</span></li> */}
                {/* <li><span className="name">Take-Off w/ Service</span><span className="dots"></span><span className="price">$9</span></li> */}
              </ol>
            </div>
          </div>

          <div className='services-content-2'>
            <div className='services-left-2'>
              <ol className='list-order'>
                <div className='services-title'>
                  <span>FULL SET</span> 
                </div> 
                <li><span className="name">Regular Acrylic</span><span className="dots"></span><span className="price">$39+</span></li>
                <li><span className="name">Full Set w/ Gel Color</span><span className="dots"></span><span className="price">$49+</span></li>
                <li><span className="name">Solar White Tips</span><span className="dots"></span><span className="price">$49+</span></li>
                <li><span className="name">Organic Dipping Powder</span><span className="dots"></span><span className="price">$45+</span></li>
                <li><span className="name">Take-off w/ Dipping Powder</span><span className="dots"></span><span className="price">$55+</span></li>
                <li><span className="name">Solar Pink & White</span><span className="dots"></span><span className="price">$63+</span></li>
                <li><span className="name">Powder Color</span><span className="dots"></span><span className="price">$55+</span></li>
                <li><span className="name">Gel X</span><span className="dots"></span><span className="price">$55+</span></li>
                <li><span className="name">IBD Gel</span><span className="dots"></span><span className="price">$58+</span></li>
                <li><span className="name">Ombre</span><span className="dots"></span><span className="price">$58+</span></li>
                <li><span className="name">Full Set on Toes</span><span className="dots"></span><span className="price">$39</span></li>
                <li><span className="name">Take-off Only</span><span className="dots"></span><span className="price">$15</span></li>
                <li><span className="name">Take-off w/New Set or Manicure, Dipping</span><span className="dots"></span><span className="price">$7</span></li>
              </ol>
            </div>
            <div className='services-middle-2'>
              <ol className='list-order'>
                <div className='services-title'>
                  <span>WAXING SERVICES</span> 
                </div> 
                <li><span className="name">Eyebrows</span><span className="dots"></span><span className="price">$12</span></li>
                <li><span className="name">Upper Lip</span><span className="dots"></span><span className="price">$8</span></li>
                <li><span className="name">Chin Forehead</span><span className="dots"></span><span className="price">$11</span></li>
                <li><span className="name">Sideburns</span><span className="dots"></span><span className="price">$15</span></li>
                <li><span className="name">Full Face</span><span className="dots"></span><span className="price">$39</span></li>
                <li><span className="name">Chest</span><span className="dots"></span><span className="price">$29+</span></li>
                <li><span className="name">Back</span><span className="dots"></span><span className="price">$41+</span></li>
                <li><span className="name">Under Arms</span><span className="dots"></span><span className="price">$17</span></li>
                <li><span className="name">Half Arm</span><span className="dots"></span><span className="price">$27+</span></li>
                <li><span className="name">Full Arm</span><span className="dots"></span><span className="price">$39+</span></li>
                <li><span className="name">Half Legs</span><span className="dots"></span><span className="price">$39+</span></li>
                <li><span className="name">Full Legs</span><span className="dots"></span><span className="price">$56+</span></li>
                <li><span className="name">Bikini</span><span className="dots"></span><span className="price">$35+</span></li>
                <li><span className="name">Brazilian</span><span className="dots"></span><span className="price">$51+</span></li>
                <p className="note2">* Please allow 24 hours after waxing before sunbathing or tanning. Newly waxed skin is more sensitive to the sun and will burn easily.</p>
                <p className="note2">* If Accutane, Retin-A or any other skin medication has been used in the last 4 months, waxing cannot be perfomed.</p>
              </ol>
            </div>
            <div className='services-right-2'>
              <ol className='list-order'>
                <div className='services-title'>
                  <span>ADDITIONAL SERVICES</span> 
                </div> 
                <li><span className="name">Add-on Gel Color Hand/Feet</span><span className="dots"></span><span className="price">$17</span></li>
                <li><span className="name">One Nail Repair</span><span className="dots"></span><span className="price">$5+</span></li>
                <li><span className="name">French</span><span className="dots"></span><span className="price">$7</span></li>
                <li><span className="name">Low French</span><span className="dots"></span><span className="price">$15</span></li>
                <li><span className="name">Ombre Color</span><span className="dots"></span><span className="price">$9</span></li>
                <li><span className="name">Cuticle Trimming w/ Service</span><span className="dots"></span><span className="price">$7</span></li>
                <li><span className="name">Cuticle Trimming w/o Service</span><span className="dots"></span><span className="price">$15</span></li>
                <li><span className="name">Gel Top / Mate Top</span><span className="dots"></span><span className="price">$7</span></li>
                <li><span className="name">Callus Remove</span><span className="dots"></span><span className="price">$7</span></li>
                <li><span className="name">Buff Cream</span><span className="dots"></span><span className="price">$7</span></li>
                <li><span className="name">Two Nails Design</span><span className="dots"></span><span className="price">$6</span></li>
                <li><span className="name">10 Nails Design or Chrome</span><span className="dots"></span><span className="price">$17+</span></li>
                <li><span className="name">Polish Change Hand/Feet</span><span className="dots"></span><span className="price">$12/17</span></li>
                <li><span className="name">French Change Hand/Feet</span><span className="dots"></span><span className="price">$17/22</span></li>
                <li><span className="name">Paraffin Wax Hand/Feet</span><span className="dots"></span><span className="price">$7/9</span></li>
                <li><span className="name">Long Nails, Almond or Coffin Shapes</span><span className="dots"></span><span className="price">$3+</span></li>
              </ol>
            </div>
          </div>

          <div className='services-content-3'>
            <div className='services-left-3'>
              <ol className='list-order'>
                <div className='services-title'>
                  <span>CHILDREN MANICURE & PEDICURE</span> 
                </div> 
                {/* <hr/> */}
                <li><span className="name">Regular Manicure</span><span className="dots"></span><span className="price">$13</span></li>
                <li><span className="name">Manicure with Gel Color</span><span className="dots"></span><span className="price">$26</span></li>
                <li><span className="name">Spa Pedicure</span><span className="dots"></span><span className="price">$22</span></li>
                <li><span className="name">Spa Pedicure with Gel Color</span><span className="dots"></span><span className="price">$33</span></li>
                <li><span className="name">Polish on Hands/Toes</span><span className="dots"></span><span className="price">$9</span></li>
                <li><span className="name">Two Nails Design</span><span className="dots"></span><span className="price">$4</span></li>
              </ol>
            </div>
            <div className='services-middle-3'>
              <ol className='list-order'>
                <div className='services-title'>
                  <span>FACIAL TREATMENT</span> 
                </div> 
                {/* <hr/> */}
                <li><span className="name">Plain Facial</span><span className="dots"></span><span className="price">$49</span></li>
                <li><span className="name">European Facial</span><span className="dots"></span><span className="price">$65</span></li>
                <li><span className="name">Acne Treatment</span><span className="dots"></span><span className="price">$75</span></li>
              </ol>
            </div>
            <div className='services-right-3'>
              <ol className='list-order'>
                <div className='services-title'>
                  <span>EYELASH EXTENSION</span> 
                </div> 
                {/* <hr/> */}
                <li><span className="name">Full Set Eyelash Extension</span><span className="dots"></span><span className="price">$119+</span></li>
                <li><span className="name">Refill Eyelash Extension</span><span className="dots"></span><span className="price">$85+</span></li>
              </ol>
            </div>
          </div>
        </div>
      </div>
      <Footer />
    </>
  )
}

export default Services